import { Base, Img, Span } from "@codesuma/baseline"
import images from '../../configs/images'

// Sign in with Apple — required on iOS whenever a third-party login (Google) is
// offered (App Store Guideline 4.8). Rendered as the prominent (solid) button.
export const AppleButton = () => {
    const base = Base()
    const apple = Img(images.icons.apple, { width: 18 })
    const txt = Span('Sign in with Apple')
    txt.style({
        marginLeft: '10px',
    })

    base.append(apple, txt)
    base.style({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #eee',
        borderRadius: '10px',
        padding: '10px',
        width: '100%',
        cursor: 'pointer',
        color: '#000',
        backgroundColor: '#fff',
        '&:hover': {
            backgroundColor: '#fefefe',
        }
    })

    base.el.onclick = async () => {
        txt.text('Signing in...')
        base.emit('request-login')
    }

    // Restores the label after a cancelled/failed attempt so the button doesn't
    // read "Signing in..." forever.
    return Object.assign(base, {
        reset: () => txt.text('Sign in with Apple'),
    })
}
